import { render, staticRenderFns } from "./StockInvoiceLinkDialog.vue?vue&type=template&id=36beba15"
import script from "./StockInvoiceLinkDialog.vue?vue&type=script&lang=js"
export * from "./StockInvoiceLinkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports